// Module
var code = "<div >\n    <div class=\"row\">\n        <button material raised>Button</button>\n    </div>\n    <div class=\"row\" >\n     \n    </div>\n</div>\n";
// Exports
module.exports = code;